<div class="container">
    <div class="row">
        <div class="col-md-8 col-md-offset-2">
            <div class="panel panel-default">
                <div class="panel-heading">Login</div>
                <div class="panel-body">
                    <form class="form-horizontal" role="form" (submit)="onLogin(loginForm)" #loginForm="ngForm">                       
                        <div class="form-group">
                            <label for="email" class="col-md-4 control-label">Username</label>
                            <div class="col-md-6">
                                <input ngModel type="email" class="form-control" name="email" required>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="password" class="col-md-4 control-label">Password</label>
                            <div class="col-md-6">
                                <input ngModel type="password" class="form-control" name="password" required>
                            </div>
                        </div>

                        <!--div class="form-group">
                            <div class="col-md-6 col-md-offset-4">
                                <div class="checkbox">
                                    <label>
                                        <input ngModel type="checkbox" name="remember"> Remember Me
                                    </label>
                                </div>
                            </div>
                        </div-->
                        <div *ngIf="isLoading" class="row center" style="margin-top:5px;">
                            <div class="spinner-border2 text-danger" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="col-md-6 col-md-offset-4">
                                <button [disabled]="loginForm.invalid || isSubmitted" type="submit" class="btn btn-primary">
                                    <i class="fa fa-btn fa-sign-in"></i> Login
                                </button>
                                <!--a class="btn btn-link" href="">Forgot Your Password?</a-->
                                <p *ngIf="isError" class="error">{{ isError }}</p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>